import {
  ContainerTemplateFragment,
  TemplateFragment,
  TextTemplateFragment,
  ImageTemplateFragment,
  ListTemplateFragment,
} from '../../../client/templates/templates';

export type PresentationFragmentTypes =
  | TextTemplateFragment
  | ImageTemplateFragment
  | ListTemplateFragment;

export type FlatLayout = {
  containerFragments: ContainerTemplateFragment[];
  presentationFragments: PresentationFragmentTypes[];
};

export function flattenLayout(layout: TemplateFragment, accumulator?: FlatLayout): FlatLayout {
  const fragments = accumulator ?? {
    containerFragments: [],
    presentationFragments: [],
  };
  if (layout.type === 'container') {
    fragments.containerFragments.push(layout);
    Array.isArray(layout.children) &&
      layout.children.forEach((fragment) => {
        flattenLayout(fragment, fragments);
      });
  } else {
    fragments.presentationFragments.push(layout);
  }
  return fragments;
}
